export default __webpack_public_path__ + "static/media/0xb85517b87bf64942adf3a0b9e4c71e4bc5caa4e5.6ad10edf.webp";